@if (standardCollection$ | async; as standardCollection) {
  <aside
    id="standardsContainer"
    [ngClass]="isExpanded ? 'student-objectives-expanded' : 'student-objectives-collapsed'"
    [class]="customClass ?? ''">
    <button (click)="toggleStudentObjectivesDisplay()" [attr.aria-expanded]="isExpanded" class="student-objectives-header">
      <div class="student-objectives-header-title">
        <h2 id="studentObjectivesLabel" class="student-objectives-header-text">{{title}}</h2>
      </div>
      @if (isExpanded) {
        <zbp-icon
          [iconName]="arrowChevronUpIconName"
          class="objectives-chevron"
        ></zbp-icon>
      } @else {
        <zbp-icon
          [iconName]="arrowChevronDownIconName"
          class="objectives-chevron"
        ></zbp-icon>
      }
    </button>
    @if (isExpanded) {
      <div class="student-objectives-container">
        @for (standard of standardCollection.standards; track i; let i = $index) {
          <ng-container
            [ngTemplateOutlet]="level"
            [ngTemplateOutletContext]="{ section: standard, uniqueIdentifierPrefix: 'standard_' + i, containerClass: 'first-level'}"
          ></ng-container>
        }
      </div>
    }
  </aside>
}

 <!-- uniqueIdentifierPrefix is built starting at the first layer and appends a subindex for each nested item -->
<ng-template #level let-section="section" let-uniqueIdentifierPrefix="uniqueIdentifierPrefix" let-containerClass="containerClass">
  <ul [class]="containerClass ? 'list-container list-container-' + containerClass : 'list-container' ">
    <li>
      @if (!section.standardCode) {
        <div class="list-item-control">
          <div class="standard-section">
            <!-- Standards without codes are bold -->
            <label [class]="containerClass ? 'standard-section-name standard-section-name-' + containerClass : 'standard-section-name'">{{section.standardDescription}}
            @if (section.depthFormatting > 1 && section.subStandards?.length > 0) {
              <zbp-button-component
                [iconName]="!!expandedSections[uniqueIdentifierPrefix] ? arrowChevronUpIconName : arrowChevronDownIconName"
                [ariaExpanded]="!!expandedSections[uniqueIdentifierPrefix] ? true : false"
                class="px-1"
                theme="icon"
                iconSize="font-size"
                [attr.aria-controls]="uniqueIdentifierPrefix"
                (click)="toggleSection(uniqueIdentifierPrefix)">
              </zbp-button-component>
            }
            </label>
          </div>
        </div>

      } @else {
        <!-- Standards with codes have blue bold codes -->
         <div class="list-item-control standard-section">
          <label class="standard-text">
            <!-- Include space between code and description -->
            <span class="standard-code">{{section.standardCode}} </span>
            <span [innerHTML]="section.standardDescription"></span>
            <!-- If there are subStandards, show a button to toggle the subStandard section -->
            @if (section.subStandards?.length > 0) {
              <zbp-button-component
                [iconName]="!!expandedSections[uniqueIdentifierPrefix] ? arrowChevronUpIconName : arrowChevronDownIconName"
                [ariaExpanded]="!!expandedSections[uniqueIdentifierPrefix] ? true : false"
                class="px-1"
                theme="icon"
                iconSize="font-size"
                [attr.aria-controls]="uniqueIdentifierPrefix"
                (click)="toggleSection(uniqueIdentifierPrefix)">
              </zbp-button-component>
            }
          </label>
         </div>
      }
      <!-- Create a new list using this template for subStandards. -->
      <!-- SubStandards can be n-levels deep -->
      @if (section.subStandards && section.subStandards.length > 0) {
         <!-- Can be collapsed on first level when there is a code. Or after the first level if there isn't a code and depthFormatting is > 1 -->
        <div [id]="uniqueIdentifierPrefix" class="sub-standards-container"
          [class.hide-section]="((section.standardCode || (!section.standardCode && section.depthFormatting > 1)) && section.subStandards?.length > 0) && (uniqueIdentifierPrefix.split('_').length > 2) && !expandedSections[uniqueIdentifierPrefix]"
          [class.show-section]="isPrinting || expandedSections[uniqueIdentifierPrefix]"
        >
          @for (subStandard of section.subStandards; track $index;  let subIndex = $index) {
            <ng-container
              [ngTemplateOutlet]="level"
              [ngTemplateOutletContext]="{ section: subStandard, uniqueIdentifierPrefix: uniqueIdentifierPrefix + '_' + subIndex }"
            ></ng-container>
          }
        </div>
      }
    </li>
  </ul>
</ng-template>
